import moment from "moment";
/* Redux */
import store from "../store/index";
import { setLastBackTimestamp, setOverlay, start, setProdotto, setFiliale, setDove, setDoveNoReset, setOrario, setGiorno, setGiornoOnly, setCF, setRecap, setModificando, setFlussoModifica, setVecchioAppuntamento, setCapExcluded, startBackEvent, endBackEvent, setHistoryBack } from "../actions/index";
/* Helpers */
import utils from "../modules/utils";
import history from "../modules/history";
import { trackPageView } from "../modules/datalayer";
import { importDataQualityPixel } from '../modules/pixels/pixels';

const { objectIsEmpty } = utils;

const getReduxState = () => {
  return store.getState();
}

function dispatchReduxAction(action) {
  store.dispatch(action);
}

const handleUrlParameters = () => {
  // TODO: migliorabile
  let queryString = window.localStorage.getItem("qs") || "";

  if (!window.localStorage.getItem("pending_qs_remove")) {
    let parameters = window.location.href.split("?")[1];

    if (parameters && parameters != "") {
      queryString = window.location.href.split("?")[1];
    }
  } else {
    window.localStorage.removeItem("pending_qs_remove")
  }

  if (queryString) {
    window.localStorage.setItem("qs", queryString);
  }

  return queryString;
}

function removeProdottoFromQueryString() {
  let queryString = window.localStorage.getItem("qs");
  const regex = /[&]?prodotto=[-]?\d{1,2}/;

  if (queryString && regex.test(queryString)) {
    queryString = queryString.replace(regex, '');

    if (queryString[0] === "&") {
      queryString = queryString.substr(1);
    }

    window.localStorage.setItem("qs", queryString);
    window.localStorage.setItem("pending_qs_remove", "true");
  }
}

const isDefined = (variable) => {
  return typeof variable !== "undefined";
}

const getFinalPath = (page) => {
  const basePath = "/fissa-appuntamento";
  
  return basePath + page;
}

const goToPage = (page, queryString) => {
  if (queryString) {
    page = page + "?" + queryString;
  }
  
  dispatchReduxAction(setOverlay(
    {
      loader: {
        isVisible: false,
      }
    }
    ));
    
  importDataQualityPixel(page);

  history.push(page);
}

const checkThankYouPageConditions = (state) => {
  if (!objectIsEmpty(state)) {
    const { utente: user } = state;

    if (!objectIsEmpty(user) && user.nome && user.cognome && user.email && user.telefono && user.cap && isDefined(user.consensi) && user.consensi && isDefined(user.consensi.informativa) && isDefined(user.consensi.dati_personali) && isDefined(user.consensi.societa_terze) && !user.token && state.filiale && state.orario_appuntamento && isDefined(state.recap_cf_accettato)) {
      if (state.prodotto == -2) {
        return "richiamami";
      }

      if (state.cap_excluded) {
        return "ti ricontatteremo forzato per cap";
      }

      if (state.prodotto == 3) {
        if (state.flusso_modifica) {
          if (state.modificando) {
            return "conferma modifica";
          } else {
            return "riepilogo modifica";
          }
        }

        return "compass quinto";
      }

      if (state.prodotto == 5) {
        return "prestito business";
      }

      if (state.data_appuntamento) {
        if (state.flusso_modifica) {
          if (state.modificando) {
            return "conferma modifica";
          } else {
            return "riepilogo modifica";
          }
        }

        if (state.ricontatto_richiesto) { //Non ha una filiale vicina e vuole essere ricontattato da un agente
          return "ricontatto";
        }

        return "standard";
      }
    }
  }

  return "";
}

const checkDatiPersonaliConditions = (state) => {
  if (!objectIsEmpty(state)) {
    if (isDefined(state.recap_cf_accettato) && state.utente && state.utente.codice_fiscale && state.filiale) {
      if (state.cap_excluded) {
        return "ti ricontatteremo forzato per cap";
      }
      
      if (state.prodotto == -2) {
        return "richiamami";
      }
  
      // Dovrebbe essere stato rimosso come ramo del flusso. Comunque è testabile inserendo il codice fiscale ZPPLVI83R31E514A
      if ( 
        (state.recap_cf_accettato == false && state.prodotto != 1)
        || 
        (
          state.recap_cf_accettato == false
          && state.prodotto == 1  && state.data_appuntamento && state.orario_appuntamento
          &&
          ( 
            state.utente 
            && (state.utente.nome && state.utente.nome != "")
            && (state.utente.cognome && state.utente.cognome != "")
            && (state.utente.email && state.utente.email != "")
            && (state.utente.telefono && state.utente.telefono != "")
            && (state.utente.codice_fiscale && state.utente.codice_fiscale != "")
          ) 
        )
      )
      {
        return "riconosciuto";
      }

      /**
       * Update by DM on 10/06/2021
       */
      if (
          state.prodotto != 3 
          || ( state.prodotto == 3 && state.data_appuntamento && state.orario_appuntamento )
          || ( (state.prodotto == 1 || state.prodotto == 4 ) && state.data_appuntamento && state.orario_appuntamento
                && 
                ( 
                  !state.utente 
                  || 
                  (
                    (!state.utente.nome || state.utente.nome == "")
                    || (!state.utente.cognome || state.utente.cognome == "")
                    || (!state.utente.email || state.utente.email == "")
                    || (!state.utente.telefono || state.utente.telefono == "")
                    || (!state.utente.codice_fiscale || state.utente.codice_fiscale == "")
                  ) 
                )
            )
        ) {
        return "standard";
      }
    }
  }
  
  return "";
}

const checkCodiceFiscaleConditions = (state) => {
  if (!objectIsEmpty(state)) {
    if (state.cap_excluded) {
      return "ti ricontatteremo forzato per cap";
    }

    if (state.prodotto == 3 || state.filiale && state.orario_appuntamento) {
      return "standard";
    }
  }
  
  return "";
}

const checkSceltaFilialeConditions = (state) => {
  if (!objectIsEmpty(state)) {
    if (state.data_appuntamento) {
      return true;
    }
  }
  
  return false;
}

const checkDataAppuntamentoConditions = (state) => {
  let valid = false;
  if (!objectIsEmpty(state)) {
    if (!state.modificando) {
      if (state.luogo || (state.tipo_appuntamento && state.flusso_modifica)) {
        valid = true;
      }
    } else {
      if (state.coordinate_luogo) {
        valid = true;
      }
    }
  }

  return valid;
}

const checkScegliDoveConditions = (state) => {
  if (!objectIsEmpty(state)) {
    if (state.telefonico_forzato || window.location.pathname == "/fissa-appuntamento/scegli-dove") {
      return true;
    }
  }
  
  return false;
}

const checkScegliLuogoConditions = (state) => {
  if (!objectIsEmpty(state)) {
    if (state.tipo_appuntamento) {
      return true;
    }
  }
  
  return false;
}

export const skipDataAppuntamento = function() {
  dispatchReduxAction(setOrario('--'));
}

export const skipScegliLuogo = function() {
  dispatchReduxAction(setFiliale({ id: '-1', nome: 'Home Appointment', indirizzo: '' }));
}

export const enterInSpecificFlow = function(product) {
  if (product === -1) {
    dispatchReduxAction(setProdotto(product));
    dispatchReduxAction(skipScegliLuogo());
    dispatchReduxAction(skipDataAppuntamento());
    dispatchReduxAction(setCapExcluded(true));
  } else {
    dispatchReduxAction(setProdotto(product));
  }

  handleFlow();
}

export const goToChangeAppointment = function() {
  const reduxState = getReduxState();
  
  dispatchReduxAction(setModificando(true));

  // if (reduxState.prodotto == 3) {
  //   dispatchReduxAction(setGiornoOnly(""));
  //   dispatchReduxAction(setOrario(""));
  // } else {
  // }
  dispatchReduxAction(setGiorno(""));

  if (!reduxState.flusso_modifica) {
    dispatchReduxAction(setVecchioAppuntamento(reduxState));
    dispatchReduxAction(setFlussoModifica(true));
    dispatchReduxAction(setDoveNoReset({
      luogo: reduxState.luogo,
      coordinate_luogo: '',
    }));
  }

  handleFlow();
}

export const goToHomepage = function() {
  dispatchReduxAction(start());
  dispatchReduxAction(setOverlay({
    loader: {
      isVisible: false,
    }
  }));
  handleFlow();
}

export const goToContactCenter = function(filiali) {
  if (filiali) {
    const { filiale_selezionata: idFiliale, nome_filiale_selezionata: nomeFiliale } = filiali;

    if (idFiliale && nomeFiliale) {
      dispatchReduxAction(setFiliale({ id: idFiliale, nome: nomeFiliale, indirizzo: '' }));
      dispatchReduxAction(setOrario('--'));
      dispatchReduxAction(setProdotto(-2));
      handleFlow();
    }
  }
}

export const goBack = function() {
  if (!getReduxState().dati_locali.processingBack) {
    const currentPath = window.location.pathname;

    dispatchReduxAction(startBackEvent());

    switch (currentPath) {
      case getFinalPath('/dati-personali'):
      case getFinalPath('/dati-personali-richiamami'):
      case getFinalPath('/dati-personali-riconosciuto'):
        console.log('qui');
        if (!getReduxState().modificando && getReduxState().prodotto !== 3) {
          console.log('1');
          dispatchReduxAction(setCF(null));
          dispatchReduxAction(setRecap(false));
        } else {
          console.log('2');
          dispatchReduxAction(setFiliale({
            id: '',
            nome: '',
            indirizzo: '',
          }));
          dispatchReduxAction(setOrario(''));
        }
        break;
      case getFinalPath('/codice-fiscale'):
        dispatchReduxAction(setFiliale({
          id: '',
          nome: '',
          indirizzo: '',
        }));
        dispatchReduxAction(setOrario(''));

        if (getReduxState().prodotto === 3 || getReduxState().prodotto === 5) {
          dispatchReduxAction(setProdotto(''));
        }

        break;
      case getFinalPath('/scelta-filiale'):
        dispatchReduxAction(setGiorno(''));
        break;
      case getFinalPath('/data-appuntamento'):
        if (!getReduxState().modificando) {
          dispatchReduxAction(setDove({
            luogo: '',
            coordinate_luogo: {
              lat: '',
              lng: '',
            }
          }));
        }
        break;
      case getFinalPath('/scegli-dove'):
        removeProdottoFromQueryString();
        dispatchReduxAction(setProdotto(''));

        break;
      case getFinalPath('/scegli-luogo'):
        if (getReduxState().prodotto === 3) {
          dispatchReduxAction(setCF(null));
          dispatchReduxAction(setRecap(false));
        } else {
          removeProdottoFromQueryString();
          dispatchReduxAction(setProdotto(''));
        }

        break;
      default:
    }

    dispatchReduxAction(endBackEvent());
    dispatchReduxAction(setHistoryBack(''));
    handleFlow();

    if (window.location.pathname === getFinalPath('')) {
      trackPageView('/');
    }
  }
}

export const switchToPrestitoPersonale = function(options = { disableRedirect: false, userDataExists: false }) {
  // Ti porta all'inizio del flusso "Prestito Personale"
  dispatchReduxAction(setProdotto(1));
  dispatchReduxAction(setFiliale({
    id_filiale: null,
    filiale: null,
    indirizzo_filiale: null,
  }));
  dispatchReduxAction(setOrario(null));

  if (options.userDataExists) {
    dispatchReduxAction(setRecap(false));
  } else {
    dispatchReduxAction(setRecap(true));
  }

  if (options.fromStart) {
    dispatchReduxAction(setDove(
      {
        luogo: '',
        coordinate_luogo: {
          lat: '',
          lng: '',
        }
      }
    ))
  }

  if (!options.disableRedirect) {
    handleFlow();
  }
}

const checkPrivacyECondizioniConditions = (state) => {
  const queryString = handleUrlParameters();
  if (queryString) {
    const params = queryString.split("&");
    const qsParams = {};
    for (let p in params) {
      const param = params[p];
      const key = param.split("=")[0];
      const val = param.split("=")[0];
      qsParams[key] = val;
    }
    if (
      qsParams.hasOwnProperty("nome") && qsParams.nome != ""
      && qsParams.hasOwnProperty("token") && qsParams.token != ""
    ) {
      return true;
    }
  }
  return false;
}

const checkTYPPrivacyECondizioniConditions = (state) => {
  const queryString = handleUrlParameters();
  if (queryString) {
    const params = queryString.split("&");
    const qsParams = {};
    for (let p in params) {
      const param = params[p];
      const key = param.split("=")[0];
      const val = param.split("=")[0];
      qsParams[key] = val;
    }
    if (
      qsParams.hasOwnProperty("nome") && qsParams.nome != ""
      && qsParams.hasOwnProperty("token") && qsParams.token != ""
      && state.ricontatto_richiesto==true
    ) {
      return true;
    }
  }
  return false;
}

export const handleFlow = () => {
  const reduxState = getReduxState();
  const { last_back_timestamp: lastBackTime, prodotto } = reduxState;
  const timeFromLastChange = moment().diff(moment.unix(lastBackTime));

  if (!lastBackTime || timeFromLastChange > 1000) {
    const queryString = handleUrlParameters();
    
    dispatchReduxAction(setLastBackTimestamp());

    switch (Number(prodotto)) {
      case -2: {
        /* TELEFONICO / TELEFONICO FORZATO PER URL */
        // Questo flusso ha 2 accessi possibili: o con url "/scegli-dove" o con parametro "prodotto=-2"
        if (checkThankYouPageConditions(reduxState) === "richiamami") {
          goToPage(getFinalPath('/typ_RICHIAMAMI'), queryString);
          break;
        }
        
        if (checkDatiPersonaliConditions(reduxState) === "richiamami") {
          goToPage(getFinalPath('/dati-personali-richiamami'), queryString);
          break;
        }

        if (checkCodiceFiscaleConditions(reduxState) === "standard") {
          goToPage(getFinalPath('/codice-fiscale'), queryString);
          break;
        }
      
        if (checkSceltaFilialeConditions(reduxState)) {
          goToPage(getFinalPath('/scelta-filiale'), queryString);
          break;
        }
      
        // Se scelgo "appuntamento telefonico" va direttamente a codice fiscale e poi a dati personali richiamami

        if (checkDataAppuntamentoConditions(reduxState)) {
          goToPage(getFinalPath('/data-appuntamento'), queryString);
          break;
        }

        // Accedo a telefonico forzato (se accesso diretto a "/scegli-dove")
        if (checkScegliDoveConditions(reduxState)) {
          goToPage(getFinalPath('/scegli-dove'), queryString);
          break;
        }

        if (checkScegliLuogoConditions(reduxState)) {
          goToPage(getFinalPath('/scegli-luogo'), queryString);
          break;
        }

        goToPage(getFinalPath(''), queryString);
        break;
      }
      case -1: {
        /* TI RICONTATTEREMO FORZATO PER CAP */
        // Si arriva necessariamente da un altro flusso
        if (checkThankYouPageConditions(reduxState) === "ti ricontatteremo forzato per cap") {
          // !attenzione: la thank you page agganciata a questo caso deve essere "thank_you_page_cq_old", deve pero essere riallacciata al routing
          goToPage(getFinalPath('/thank-you-page-CQ-old'), queryString);
          break;
        }

        if (checkDatiPersonaliConditions(reduxState) === "ti ricontatteremo forzato per cap") {
          goToPage(getFinalPath('/dati-personali'), queryString);
          break;
        }

        if (checkCodiceFiscaleConditions(reduxState) === "ti ricontatteremo forzato per cap") {
          goToPage(getFinalPath('/codice-fiscale'), queryString);
          break;
        }
      }
      case 1: {
        /* PRESTITO PERSONALE */
        if (checkThankYouPageConditions(reduxState)) {
          const thankYouPageFlow = checkThankYouPageConditions(reduxState);
          let url = '';

          if (thankYouPageFlow === "standard") {
            url = "/thank-you-page";
          } else if (thankYouPageFlow === "riepilogo modifica") {
            url = "/riepilogo-modifica-appuntamento";
          } else if (thankYouPageFlow === "conferma modifica") {
            url = "/conferma-modifica-appuntamento";
          } else if (thankYouPageFlow === "ricontatto") { //Compass LINK
            url = "/thank-you-page-clink";
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }
      
        if (checkDatiPersonaliConditions(reduxState)) {
          const datiPersonaliFlow = checkDatiPersonaliConditions(reduxState);
          let url = '';

          if (datiPersonaliFlow === "standard") {
            url = '/dati-personali';
          } else if (datiPersonaliFlow === "riconosciuto") {
            url = '/dati-personali-riconosciuto';
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }
      
        if (checkCodiceFiscaleConditions(reduxState) === "standard") {
          goToPage(getFinalPath('/codice-fiscale'), queryString);
          break;
        }

        if (checkSceltaFilialeConditions(reduxState)) {
          goToPage(getFinalPath('/scelta-filiale'), queryString);
          break;
        }

        if (checkDataAppuntamentoConditions(reduxState)) {
          goToPage(getFinalPath('/data-appuntamento'), queryString);
          break;
        }
        if (checkTYPPrivacyECondizioniConditions(reduxState)) {
          goToPage(getFinalPath('/thank-you-page-clink-CC'), queryString);
          break;
        }
        if (checkPrivacyECondizioniConditions(reduxState)) {
          goToPage(getFinalPath('/privacy-e-consensi'), queryString);
          break;
        }
        if (checkScegliLuogoConditions(reduxState)) {
          goToPage(getFinalPath('/scegli-luogo'), queryString);
          break;
        }
        goToPage(getFinalPath(''), queryString);
        break;
      }
      case 3: {
        /* CESSIONE DEL QUINTO */
        if (checkThankYouPageConditions(reduxState)) {
          const thankYouPageFlow = checkThankYouPageConditions(reduxState);
          let url = '';

          if (thankYouPageFlow === "compass quinto") {
            url = "/thank-you-page-CQ";
          } else if (thankYouPageFlow === "riepilogo modifica") {
            url = "/riepilogo-modifica-appuntamento";
          } else if (thankYouPageFlow === "conferma modifica") {
            url = "/conferma-modifica-appuntamento";
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }
        
        if (checkDatiPersonaliConditions(reduxState)) {
          let url = '';

          if (checkDatiPersonaliConditions(reduxState) === "standard") {
            url = '/dati-personali';
          } else if (checkDatiPersonaliConditions(reduxState) === "riconosciuto") {
            url = '/dati-personali-riconosciuto';
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }

        if (checkSceltaFilialeConditions(reduxState) && reduxState.utente && reduxState.utente.codice_fiscale) {
          goToPage(getFinalPath('/scelta-filiale'), queryString);
          break;
        }

        if (checkDataAppuntamentoConditions(reduxState) && reduxState.utente && reduxState.utente.codice_fiscale) {
          goToPage(getFinalPath('/data-appuntamento'), queryString);
          break;
        }

        if (checkScegliLuogoConditions(reduxState) && reduxState.utente && reduxState.utente.codice_fiscale) {
          goToPage(getFinalPath('/scegli-luogo'), queryString);
          break;
        }
        
        if (checkCodiceFiscaleConditions(reduxState)) {
          goToPage(getFinalPath('/codice-fiscale'), queryString);
          break;
        }

        goToPage(getFinalPath(''), queryString);
        break;
      }
      case 4: {
        /* CARTA DI CREDITO */
        if (checkThankYouPageConditions(reduxState)) {
          const thankYouPageFlow = checkThankYouPageConditions(reduxState);
          let url = '';

          if (thankYouPageFlow === "standard") {
            url = "/thank-you-page";
          } else if (thankYouPageFlow === "riepilogo modifica") {
            // in realtà in questo momento (2021-03-03) vieni ributtato sul "/riepilogo-modifica-appuntamento" del flusso con prodotto = 1
            url = "/riepilogo-modifica-appuntamento";
          } else if (thankYouPageFlow === "conferma modifica") {
            // in realtà in questo momento (2021-03-03) vieni ributtato sul "/conferma-modifica-appuntamento" del flusso con prodotto = 1
            url = "/conferma-modifica-appuntamento";
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }
      
        if (checkDatiPersonaliConditions(reduxState)) {
          const datiPersonaliFlow = checkDatiPersonaliConditions(reduxState);
          let url = '';

          if (datiPersonaliFlow === "standard") {
            url = '/dati-personali';
          } else if (datiPersonaliFlow === "riconosciuto") {
            url = '/dati-personali-riconosciuto';
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }

        if (checkCodiceFiscaleConditions(reduxState) === "standard") {
          goToPage(getFinalPath('/codice-fiscale'), queryString);
          break;
        }
      
        if (checkSceltaFilialeConditions(reduxState)) {
          goToPage(getFinalPath('/scelta-filiale'), queryString);
          break;
        }
      
        if (checkDataAppuntamentoConditions(reduxState)) {
          goToPage(getFinalPath('/data-appuntamento'), queryString);
          break;
        }

        if (checkScegliLuogoConditions(reduxState)) {
          goToPage(getFinalPath('/scegli-luogo'), queryString);
          break;
        }

        goToPage(getFinalPath(''), queryString);
        break;
      }
      case 5: {
        /* PRESTITO BUSINESS */
        if (checkThankYouPageConditions(reduxState) === "prestito business") {
          goToPage(getFinalPath('/thank-you-page-AUP'), queryString);
          break;
        }
        
        if (checkDatiPersonaliConditions(reduxState)) {
          const datiPersonaliFlow = checkDatiPersonaliConditions(reduxState);
          let url = '';

          if (datiPersonaliFlow === "standard") {
            url = '/dati-personali';
          } else if (datiPersonaliFlow === "riconosciuto") {
            url = '/dati-personali-riconosciuto';
          }

          if (url) {
            goToPage(getFinalPath(url), queryString);
            break;
          }
        }
        
        if (checkCodiceFiscaleConditions(reduxState) === "standard") {
          goToPage(getFinalPath('/codice-fiscale'), queryString);
          break;
        }

        goToPage(getFinalPath(''), queryString);
        break;
      }
      default:
        if (checkScegliDoveConditions(reduxState)) {
          goToPage(getFinalPath('/scegli-dove'), queryString);
          break;
        }
        if (checkTYPPrivacyECondizioniConditions(reduxState)) {
          goToPage(getFinalPath('/thank-you-page-clink-CC'), queryString);
          break;
        }
        if (checkPrivacyECondizioniConditions(reduxState)) {
          goToPage(getFinalPath('/privacy-e-consensi'), queryString);
          break;
        }

        goToPage(getFinalPath(''), queryString);
    }
  }
}



// WEBPACK FOOTER //
// ./src/flow/flow.js